@if( data.newGloss ) {
<h2 mat-dialog-title>New Gloss</h2>
} @else {
<h2 mat-dialog-title>Edit Gloss</h2>
}

<mat-dialog-content>
  <form (ngSubmit)="accept()" #myForm="ngForm">
    @if( !data.newGloss ) {
      <p class="danger">Be extremly careful here! If you edit the gloss, it will change it <em>everywhere</em> the gloss is used, not just in this verse. This should probably only used for things like fixing spelling mistakes.</p>
    }
    <!-- <p>{{data.type}}</p> -->
@if (data.type === 'word' || data.type === 'wordplusmarkdown') {
  <mat-form-field>
    <mat-label>Gloss</mat-label>
    <input matInput [(ngModel)]="gloss" cdkFocusInitial [ngModelOptions]="{standalone: true}" [appProjectTextStyle]="synchronizerService.currentProject"/>
  </mat-form-field>
}
@if (data.type === 'markdown' || data.type === 'wordplusmarkdown') {
    <mat-form-field>
    <mat-label>Markdown</mat-label>
    <input matInput [(ngModel)]="markdown" [ngModelOptions]="{standalone: true}" [appProjectTextStyle]="synchronizerService.currentProject"/>
  </mat-form-field>
  <p>Preview:</p>
  <p [innerHTML]="markdown() | markdown" [appProjectTextStyle]="synchronizerService.currentProject"></p>
}
  </form>
  @if( !data.newGloss ) {
    <button mat-stroked-button (click)="delete()" color="warn" class="delete"><mat-icon>delete</mat-icon>Delete This Gloss</button>
  }

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onDismiss()">Dismiss</button>
  @if( data.newGloss ) {
    <button mat-flat-button (click)="accept()">Add Gloss</button>
  } @else {
    <button mat-flat-button (click)="accept()">Edit Gloss</button>
  }
</mat-dialog-actions>
